import React from 'react';
import TonicDominantSpellInputs from './TonicDominantSpellInputs';
import {TRIAD_QUALITY_GROUPS} from '../editor/majorTriadSpellModel.js';
const columns='80px repeat(4, 230px)';
export default function TriadQualitiesSpellInputs({config,value={},onChange,mode,feedback}) {
 return <div style={{display:'flex',flexDirection:'column',gap:20,width:1192,flexShrink:0}}>
  <div style={{display:'grid',gridTemplateColumns:columns,columnGap:48,alignItems:'center'}}>
   <span/>{TRIAD_QUALITY_GROUPS.map(group=><strong key={group.id} style={{textAlign:'center'}}>{group.label}</strong>)}
  </div>
  {(config.rows||[]).map(row=>{
   const prefix=row.id+'_';
   const rowValue=Object.fromEntries(Object.entries(value).filter(([id])=>id.startsWith(prefix)).map(([id,v])=>[id.slice(prefix.length),v]));
   const parts=Object.fromEntries(Object.entries(feedback?.parts||{}).filter(([id])=>id.startsWith(prefix)).map(([id,v])=>[id.slice(prefix.length),v]));
   const label=String(row.root).replaceAll('#','♯').replaceAll('b','♭');
   return <TonicDominantSpellInputs key={row.id}
    config={{allowDoubleAccidentals:config.allowDoubleAccidentals, singleRow:true,hideGroupHeadings:true,groups:TRIAD_QUALITY_GROUPS,keyLabel:label,ariaLabelPrefix:label,gridTemplateColumns:columns,rowWidth:1192,columnGap:48,keyLabelMinWidth:0}}
    value={rowValue} mode={mode} feedback={{parts}}
    onChange={next=>onChange({...value,...Object.fromEntries(Object.entries(next).map(([id,v])=>[prefix+id,v]))})}/>;
  })}
 </div>;
}
